import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IEdge, IWorkplaceGroup, IPageInfo } from '@api/types'
import { WorkplaceGroupSearchFragment, PageInfoFragment } from '@api/fragments'

interface WorkplaceGroupConnection {
  pageInfo: IPageInfo
  edges: IEdge<IWorkplaceGroup>[]
}

export interface Payload {
  data: {
    viewer: {
      company: {
        workplaceGroups: WorkplaceGroupConnection
      }
    }
  }
}

export const workplaceGroupSearchQuery = gql`
  query WorkplaceGroupSearch($query: String!, $after: String) {
    viewer {
      company {
        workplaceGroups(
          first: 7
          after: $after
          orderBy: name_ASC
          where: { name_contains: $query }
        ) {
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...WorkplaceGroupSearchFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${WorkplaceGroupSearchFragment}
`

export default function search({
  query,
  after,
}: {
  query: string
  after?: string
}): Promise<WorkplaceGroupConnection> {
  const variables = { query, after }
  return client.gql.query({ query: workplaceGroupSearchQuery, variables }).then(
    ({
      data: {
        viewer: {
          company: { workplaceGroups },
        },
      },
    }: Payload) => workplaceGroups
  )
}
